import { useEffect, useState } from "react";
import {
  Box,
  Grid,
  GridItem,
  Button,
  Select,
  Text,
  FormControl,
  FormLabel,
  useToast,
  Flex,
  useDisclosure,
} from "@chakra-ui/react";
import Notification from "../../services/Notification";
import { useNavigate } from "react-router-dom";
import TestModal from "../Modals/TestModal";
import CreateAppNotificationModal from "../Modals/CreateAppNotificationModal";

const NotificationsTemplate = ({
  setId,
  setNotificationId,
  notificationId,
  userId,
  pageId,
}: any) => {
  const toast = useToast();
  const navigate = useNavigate();
  const token = localStorage.getItem("logged_in_user_token");
  // const [data, setData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [category, setCategory] = useState("dolphin");

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [modal, setModal] = useState("");

  const [notification, setNotification] = useState<any>([]);
  const [selectedNotification, setSelectedNotification] = useState<any>(null);

  const fetchData = () => {
    Notification.getNotification(token, page, pageSize, category)
      .then((res) => {
        // setData(res.data.data);
        setNotification(res.data.data);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          toast({
            position: "top",
            title: "Authentication Failed.",
            description: "Your session is expired.",
            status: "error",
            duration: 500,
            isClosable: true,
          });
          setTimeout(() => {
            navigate("/login");
          }, 2000);
        }
        console.log(error);
      });
  };

  const handleNotificationChange = (event: any) => {
    const notificationName = event.target.value;
    const selectedItem = notification.find(
      (item: any) => item.name === notificationName
    );
    setSelectedNotification(selectedItem || null);
    setId(selectedItem?._id);
    setNotificationId(selectedItem?._id);
  };

  const handleSend = () => {
    Notification.sendDolphinActionNotification(
      "notification",
      notificationId,
      userId
    ).then((res) => {
      // console.log(res.data);
      toast({
        position: "top",
        title: "App Notification Sent.",
        description: "App Notification is sent to the user successfully.",
        status: "success",
        duration: 1000,
        isClosable: true,
      });
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Box bg="gray.100" p={6}>
      <Grid templateColumns="repeat(3, 1fr)" gap={2}>
        <GridItem bg="#f6ffff" colSpan={2} p={8}>
          {/* <Text fontSize="lg" fontWeight="bold" mb={6}>
            Notifications
          </Text> */}
          {/* <Grid templateColumns="repeat(2, 1fr)" gap={4}> */}

          <Box mb={6} h="40px">
            <Text fontWeight="semibold">Title</Text>
            {selectedNotification && (
              <Text fontWeight="normal" mb={2}>
                {selectedNotification.title}
              </Text>
            )}
          </Box>
          <Box mb={6} h="40px">
            <Text fontWeight="semibold">Body</Text>
            {selectedNotification && (
              <Text fontWeight="normal" mb={2}>
                {selectedNotification.body}
              </Text>
            )}
          </Box>
          <Box mb={6} h="40px">
            <Text fontWeight="semibold">Path</Text>
            {selectedNotification && (
              <Text fontWeight="normal" mb={2}>
                {selectedNotification.path}
              </Text>
            )}
          </Box>
          <Box mb={6} h="40px">
            <Text fontWeight="semibold">Image URL</Text>
            {selectedNotification && (
              <Text fontWeight="normal" mb={2}>
                {selectedNotification.image_url}
              </Text>
            )}
          </Box>
        </GridItem>

        <GridItem px={6}>
          <Flex justify="flex-end" mb={4}>
            <Button
              size="sm"
              colorScheme="teal"
              onClick={() => {
                setModal("createAppNotificationModal");
                onOpen();
              }}
            >
              + Create
            </Button>
          </Flex>

          <FormControl>
            <FormLabel fontSize="md" fontWeight="bold">
              Choose Template
            </FormLabel>
            <Select
              placeholder="Select"
              value={selectedNotification?.name}
              onChange={handleNotificationChange}
            >
              {notification.map((item: any, index: any) => (
                <option key={index} value={item.name}>
                  {item.name}
                </option>
              ))}
            </Select>
          </FormControl>
        </GridItem>

        {!["leads-reachout", "customer-reachout"].includes(pageId) && (
          <Flex p={2} align="center" gap={8}>
            <Button colorScheme="yellow" size="sm" onClick={() => handleSend()}>
              SEND
            </Button>
            <Button
              colorScheme="yellow"
              size="sm"
              onClick={() => {
                setModal("testModal");
                onOpen();
              }}
            >
              SEND TO TEST USER
            </Button>
            {modal === "testModal" && (
              <TestModal
                isOpen={isOpen}
                onClose={onClose}
                templateId={notificationId}
                type="notification"
              />
            )}
          </Flex>
        )}
        {modal === "createAppNotificationModal" && (
          <CreateAppNotificationModal
            isOpen={isOpen}
            onClose={onClose}
            func={fetchData}
          />
        )}
      </Grid>
    </Box>
  );
};

export default NotificationsTemplate;
